import { useEffect, useState } from "react";
import { IoStorefrontOutline, IoScanOutline, IoBookmarkOutline, IoChatbubbleEllipsesOutline, IoAlertCircleOutline, IoArrowForward, IoClose } from "react-icons/io5";
import { useI18n } from "@/i18n";

const KEY = "tf_onboarding_v2";

const useSlides = (t) => [
  {
    Icon: IoStorefrontOutline,
    title: "Benvenuto in The First",
    body: "Gestisci prodotti, scaduti e problemi dei 4 punti vendita da un unico posto, in tempo reale.",
  },
  {
    Icon: IoScanOutline,
    title: "Scansiona e vai",
    body: "Tocca il barcode: ti compilo tutto io in automatico. Tu inserisci solo quantità e scadenza.",
  },
  {
    Icon: IoAlertCircleOutline,
    title: "Prossime Scadenze",
    body: "Ogni punto vendita ha una sezione dedicata ai prodotti in scadenza. Scansiona il barcode + la data e via, meno di 10 secondi a prodotto.",
  },
  {
    Icon: IoBookmarkOutline,
    title: "Richieste tra negozi",
    body: "Un prodotto ti serve? Aprilo, tocca Richiedi e il negozio sorgente riceve la notifica. Può accettare, rifiutare o modificare la quantità.",
  },
  {
    Icon: IoChatbubbleEllipsesOutline,
    title: "Chat 2.0",
    body: "Parla con gli altri negozi: foto, vocali, risposte, ricevute di lettura. C'è anche la chat di gruppo 'Tutti i negozi' dove parla anche il Titolare.",
  },
];

export const Onboarding = ({ children }) => {
  const { t } = useI18n();
  const slides = useSlides(t);
  const [open, setOpen] = useState(() => {
    try { return !localStorage.getItem(KEY); } catch { return false; }
  });
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (!open) return;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  // When onboarding is complete, render the rest of the app.
  // While onboarding is showing, we return ONLY the onboarding UI so that iOS/Android
  // don't detect any password/email inputs from the login page underneath and offer
  // autofill/keychain suggestions that bug the welcome flow.
  if (!open) return children || null;

  const close = () => {
    try { localStorage.setItem(KEY, "1"); } catch { /* private mode */ }
    setOpen(false);
  };

  const next = () => {
    if (idx < slides.length - 1) setIdx(idx + 1);
    else close();
  };

  const slide = slides[idx];
  const Icon = slide.Icon;

  return (
    <div className="tf-onboarding" data-testid="onboarding-overlay" role="dialog" aria-modal="true">
      <button
        type="button"
        data-testid="onboarding-skip"
        onClick={close}
        className="tf-onboarding-skip"
        aria-label="Salta"
      >
        <IoClose size={22} />
      </button>

      <div className="tf-onboarding-content" data-testid={`onboarding-slide-${idx}`}>
        <div className="tf-onboarding-icon">
          <Icon size={54} />
        </div>
        <h1 className="tf-onboarding-title">{slide.title}</h1>
        <p className="tf-onboarding-body">{slide.body}</p>
      </div>

      <div className="tf-onboarding-footer">
        <div className="tf-onboarding-dots">
          {slides.map((slide, i) => (
            <span key={`dot-${slide.title}`} className={`tf-onboarding-dot ${i === idx ? "active" : ""}`} />
          ))}
        </div>
        <button
          type="button"
          data-testid="onboarding-next"
          onClick={next}
          className="tf-btn-primary"
          style={{ minWidth: 140 }}
        >
          {idx === slides.length - 1 ? "Inizia" : "Avanti"}
          <IoArrowForward size={18} />
        </button>
      </div>
    </div>
  );
};
